import {
  BtnLanguage,
  LanguageBox,
  LanguageListBox,
  PolicyArticleTitle,
  PolicyContainer,
  PolicyHyphenList,
  PolicyList,
  PolicySectionTitle,
  PolicyTable,
  PolicyText,
  PolicyTitle,
  PolicyVersion,
  StyledIconDropdown,
  StyledIconGlobal,
} from "styles/PolicyCommon";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const PrivacyVi = () => {
  const [isOpen, setIsOpen] = useState(false);
  const onLanguageClick = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    document.documentElement.lang = "vi";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <LanguageBox isOpen={isOpen}>
        <BtnLanguage onClick={onLanguageClick}>
          <StyledIconGlobal />
          VI
          <StyledIconDropdown />
        </BtnLanguage>
        <LanguageListBox>
          <ul>
            <li>
              <Link to="/policy/en/privacy">EN</Link>
            </li>
            <li>
              <Link to="/policy/ja/privacy">JA</Link>
            </li>
            <li className="selected">
              <em>VI</em>
            </li>
            <li>
              <Link to="/policy/th/privacy">TH</Link>
            </li>
            <li>
              <Link to="/policy/id/privacy">ID</Link>
            </li>
            <li>
              <Link to="/policy/es/privacy">ES</Link>
            </li>
          </ul>
        </LanguageListBox>
      </LanguageBox>

      <PolicyTitle>pregnancy&amp;baby Chính sách quyền riêng tư</PolicyTitle>

      <PolicyVersion>
        Ngày có hiệu lực: [21 tháng 9 năm 2026]
        <br />
        Cập nhật lần cuối: [25 tháng 8 năm 2026]
      </PolicyVersion>
      <PolicyText>
        Connecti Co., Ltd. (sau đây gọi là “Connecti”, “Công ty” hoặc “chúng
        tôi”) tôn trọng quyền riêng tư của người dùng{" "}
        <strong>pregnancy&amp;baby</strong> và coi việc bảo vệ dữ liệu cá nhân
        của người dùng một cách phù hợp và an toàn là trách nhiệm quan trọng.
      </PolicyText>
      <PolicyText>
        Chính sách quyền riêng tư này giải thích loại dữ liệu cá nhân mà chúng
        tôi thu thập, mục đích xử lý, trường hợp dữ liệu có thể được chia sẻ
        hoặc chuyển giao, thời gian lưu trữ và các quyền của người dùng đối với
        dữ liệu cá nhân của mình.
      </PolicyText>
      <PolicyText>
        Chính sách này áp dụng cho ứng dụng di động{" "}
        <strong>pregnancy&amp;baby</strong>, trang web và các sản phẩm, tính
        năng, dịch vụ liên quan (gọi chung là “Dịch vụ”).
      </PolicyText>
      <PolicyText>
        Chúng tôi có thể sửa đổi Chính sách quyền riêng tư này khi cần thiết.
        Trong trường hợp có thay đổi quan trọng, chúng tôi sẽ thông báo cho
        người dùng thông qua Dịch vụ, email hoặc phương thức phù hợp khác theo
        quy định của pháp luật hiện hành. Khi pháp luật yêu cầu, chúng tôi sẽ
        xin sự đồng ý của người dùng đối với các thay đổi liên quan.
      </PolicyText>

      <PolicySectionTitle>
        1. Dữ liệu cá nhân chúng tôi thu thập
      </PolicySectionTitle>
      <PolicyText>
        Chúng tôi có thể thu thập dữ liệu do người dùng trực tiếp cung cấp, dữ
        liệu được thu thập tự động khi sử dụng Dịch vụ và một số dữ liệu được
        cung cấp thông qua dịch vụ xác thực của bên thứ ba.
      </PolicyText>

      <PolicyArticleTitle>1.1. Thông tin tài khoản và hồ sơ</PolicyArticleTitle>
      <PolicyText>
        Khi người dùng tạo hoặc sử dụng tài khoản, chúng tôi có thể thu thập:
      </PolicyText>
      <PolicyHyphenList>
        <li>Địa chỉ email</li>
        <li>Năm sinh</li>
        <li>Biệt danh</li>
        <li>Ảnh hồ sơ</li>
        <li>Khu vực cư trú</li>
        <li>Ngôn ngữ</li>
        <li>Múi giờ</li>
      </PolicyHyphenList>
      <PolicyText>
        Dữ liệu thực tế được thu thập có thể khác nhau tùy thuộc vào tính năng
        được sử dụng và phương thức đăng ký tài khoản.
      </PolicyText>

      <PolicyArticleTitle>
        1.2. Thông tin đăng nhập qua dịch vụ bên thứ ba
      </PolicyArticleTitle>
      <PolicyText>
        Người dùng có thể tạo tài khoản hoặc đăng nhập bằng:
      </PolicyText>
      <PolicyHyphenList>
        <li>Google</li>
        <li>Apple</li>
      </PolicyHyphenList>
      <PolicyText>
        Khi sử dụng dịch vụ đăng nhập của bên thứ ba, chúng tôi có thể nhận được
        từ nhà cung cấp dịch vụ đó:
      </PolicyText>
      <PolicyHyphenList>
        <li>Mã định danh tài khoản (ID)</li>
        <li>Họ tên hoặc tên hiển thị</li>
      </PolicyHyphenList>
      <PolicyText>
        Thông tin thực tế mà chúng tôi nhận được có thể khác nhau tùy thuộc vào
        nhà cung cấp dịch vụ và cài đặt của người dùng trên dịch vụ đó.
      </PolicyText>
      <PolicyText>
        Việc xử lý dữ liệu bởi các nhà cung cấp dịch vụ đăng nhập được thực hiện
        theo chính sách quyền riêng tư tương ứng của họ.
      </PolicyText>

      <PolicyArticleTitle>
        1.3. Dữ liệu về sức khỏe, chuẩn bị mang thai, thai kỳ và sức khỏe tổng
        thể
      </PolicyArticleTitle>
      <PolicyText>
        Một số tính năng của Dịch vụ cho phép người dùng tự nguyện nhập dữ liệu
        liên quan đến sức khỏe, chuẩn bị mang thai, thai kỳ và sức khỏe tổng
        thể.
      </PolicyText>
      <PolicyText>
        Tùy thuộc vào tính năng được sử dụng, dữ liệu có thể bao gồm:
      </PolicyText>

      <PolicyList>
        <li>
          <strong>Chuẩn bị mang thai</strong>
          <PolicyHyphenList>
            <li>Thời gian và chu kỳ kinh nguyệt</li>
            <li>Ngày đầu kỳ kinh gần nhất</li>
            <li>Ngày bắt đầu và kết thúc kỳ kinh</li>
            <li>Ngày rụng trứng</li>
            <li>Ngày và giờ thực hiện xét nghiệm rụng trứng</li>
            <li>Hình ảnh và kết quả xét nghiệm rụng trứng</li>
            <li>Ngày và giờ thực hiện xét nghiệm thai</li>
            <li>Hình ảnh và kết quả xét nghiệm thai</li>
            <li>Nhiệt độ cơ thể cơ bản</li>
            <li>Triệu chứng</li>
            <li>Thông tin về đau và ra máu</li>
            <li>Thông tin sử dụng thuốc</li>
            <li>Thông tin tiêm chủng</li>
            <li>Thông tin khám bệnh</li>
            <li>Thông tin về quan hệ tình dục</li>
            <li>Ghi chú và các thông tin nhật ký khác</li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>Điều trị hiếm muộn</strong>
          <PolicyHyphenList>
            <li>Phương pháp điều trị hiếm muộn</li>
            <li>Chu kỳ và số lần điều trị</li>
            <li>Ngày bắt đầu và kết thúc điều trị</li>
            <li>Thông tin sử dụng thuốc và tiêm</li>
            <li>Lịch trình và nội dung điều trị</li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>Thai kỳ</strong>
          <PolicyHyphenList>
            <li>Ngày dự sinh</li>
            <li>Tên gọi thân mật của thai nhi</li>
            <li>Tuổi thai</li>
            <li>Thông tin nhật ký thai kỳ</li>
            <li>Thông tin khám thai</li>
            <li>Thông tin tiêm chủng</li>
            <li>Thông tin cân nặng</li>
            <li>Hình ảnh siêu âm</li>
            <li>Các chỉ số thai nhi như EFW, AC, FL, BPD, HC và CRL</li>
            <li>Chiều cao và cân nặng trước khi mang thai</li>
            <li>Lịch sử thay đổi cân nặng</li>
            <li>Các thông tin khác liên quan đến thai kỳ do người dùng nhập</li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>Chăm sóc trẻ và quản lý sau sinh</strong>
          <br />
          Tùy thuộc vào tính năng được sử dụng, chúng tôi có thể xử lý các dữ
          liệu sau về trẻ:
          <PolicyHyphenList>
            <li>Họ tên của trẻ</li>
            <li>Giới tính</li>
            <li>Ngày sinh</li>
            <li>Cân nặng khi sinh</li>
            <li>Chiều cao khi sinh</li>
            <li>Vòng đầu khi sinh</li>
            <li>Ngày dự sinh</li>
            <li>Thông tin khám sức khỏe</li>
            <li>Thông tin tiêm chủng</li>
            <li>Thông tin tăng trưởng như chiều cao, cân nặng và vòng đầu</li>
            <li>Kết quả và điểm đánh giá phát triển</li>
            <li>Hình ảnh liên quan đến sự phát triển</li>
            <li>Thông tin về sinh non</li>
            <li>Thân nhiệt</li>
            <li>Thông tin sử dụng thuốc</li>
            <li>Thông tin bệnh lý</li>
          </PolicyHyphenList>
          Đối với tính năng quản lý cân nặng sau sinh, chúng tôi cũng có thể xử
          lý:
          <PolicyHyphenList>
            <li>Chiều cao và cân nặng trước khi mang thai</li>
            <li>Cân nặng ngay trước khi sinh</li>
            <li>Thông tin cân nặng sau sinh</li>
          </PolicyHyphenList>
          Một số dữ liệu nêu trên, đặc biệt là dữ liệu liên quan đến tình trạng
          sức khỏe, có thể được xem là{" "}
          <strong>ddữ liệu cá nhân nhạy cảm (dữ liệu cá nhân nhạy cảm)</strong>{" "}
          theo pháp luật hiện hành.
          <br />
          Khi pháp luật yêu cầu, chúng tôi sẽ xin sự đồng ý rõ ràng hoặc riêng
          biệt của người dùng trước khi thu thập hoặc xử lý các dữ liệu này.
        </li>
      </PolicyList>

      <PolicyArticleTitle>1.4. Thông tin cộng đồng</PolicyArticleTitle>
      <PolicyText>
        Khi người dùng sử dụng các tính năng cộng đồng của{" "}
        <strong>pregnancy&amp;baby</strong>, chúng tôi có thể xử lý:
      </PolicyText>
      <PolicyHyphenList>
        <li>Biệt danh</li>
        <li>Ảnh hồ sơ</li>
        <li>Bài đăng</li>
        <li>Bình luận</li>
        <li>Bình chọn và câu trả lời bình chọn</li>
        <li>Hình ảnh và nội dung khác mà người dùng tự nguyện đăng tải</li>
      </PolicyHyphenList>
      <PolicyText>
        Thông tin được đăng trong khu vực cộng đồng có thể hiển thị cho những
        người dùng khác. Người dùng cần thận trọng khi đăng dữ liệu cá nhân tại
        các khu vực công khai.
      </PolicyText>

      <PolicyArticleTitle>
        1.5. Dữ liệu được thu thập tự động
      </PolicyArticleTitle>
      <PolicyText>
        Khi người dùng sử dụng Dịch vụ, một số dữ liệu kỹ thuật và dữ liệu sử
        dụng có thể được thu thập tự động, bao gồm:
      </PolicyText>
      <PolicyHyphenList>
        <li>Loại và mẫu thiết bị</li>
        <li>Hệ điều hành và phiên bản</li>
        <li>Phiên bản ứng dụng</li>
        <li>Ngôn ngữ</li>
        <li>Múi giờ</li>
        <li>Địa chỉ IP</li>
        <li>Thông tin về việc sử dụng và thao tác trong ứng dụng</li>
        <li>Các tính năng được truy cập hoặc sử dụng</li>
        <li>Tần suất sử dụng</li>
        <li>Thông tin tương tác với các tính năng</li>
        <li>Dữ liệu lỗi và chẩn đoán</li>
        <li>
          Mã đăng ký FCM hoặc mã thông báo khác cần thiết để gửi thông báo đẩy
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Trang web của chúng tôi cũng có thể sử dụng cookie hoặc công nghệ tương
        tự khi cần thiết.
      </PolicyText>

      <PolicyArticleTitle>1.6. Dữ liệu phân tích</PolicyArticleTitle>
      <PolicyText>
        Chúng tôi sử dụng <strong>Google Analytics for Firebase</strong> để hiểu
        cách người dùng sử dụng Dịch vụ và cải thiện chức năng cũng như trải
        nghiệm người dùng.
      </PolicyText>
      <PolicyText>Dữ liệu phân tích có thể bao gồm:</PolicyText>
      <PolicyHyphenList>
        <li>Thông tin sử dụng ứng dụng</li>
        <li>Thông tin phiên sử dụng</li>
        <li>Hoạt động và tương tác với các tính năng</li>
        <li>Thông tin thiết bị và hệ điều hành</li>
        <li>Dữ liệu kỹ thuật và chẩn đoán chung</li>
      </PolicyHyphenList>

      <PolicySectionTitle>2. Mục đích xử lý dữ liệu cá nhân</PolicySectionTitle>
      <PolicyText>
        Chúng tôi chỉ xử lý dữ liệu cá nhân trong phạm vi cần thiết cho các mục
        đích rõ ràng và hợp pháp, bao gồm:
      </PolicyText>
      <PolicyHyphenList>
        <li>Tạo, xác thực và quản lý tài khoản</li>
        <li>Cung cấp và vận hành Dịch vụ</li>
        <li>
          Dự đoán kỳ kinh tiếp theo, thời điểm dễ thụ thai và ngày rụng trứng
        </li>
        <li>
          Ghi nhận và phân tích kết quả xét nghiệm rụng trứng và xét nghiệm thai
        </li>
        <li>Quản lý lịch trình và lời nhắc điều trị hiếm muộn</li>
        <li>Tính tuổi thai và ngày dự sinh</li>
        <li>Cung cấp nội dung và báo cáo liên quan đến thai kỳ</li>
        <li>Phân tích các chỉ số tăng trưởng của thai nhi</li>
        <li>Cung cấp chức năng quản lý cân nặng trong thai kỳ và sau sinh</li>
        <li>Cung cấp báo cáo về tăng trưởng và phát triển của trẻ</li>
        <li>
          Cung cấp chức năng quản lý sức khỏe, thân nhiệt, thuốc, tiêm chủng và
          khám sức khỏe của trẻ
        </li>
        <li>
          Cung cấp nội dung và dịch vụ được cá nhân hóa dựa trên thông tin do
          người dùng cung cấp
        </li>
        <li>Gửi lời nhắc và thông báo đẩy</li>
        <li>Phản hồi yêu cầu và cung cấp hỗ trợ khách hàng</li>
        <li>Bảo đảm tính an toàn và toàn vẹn của Dịch vụ</li>
        <li>
          Phát hiện và ngăn chặn hành vi sử dụng trái phép hoặc truy cập trái
          phép
        </li>
        <li>Theo dõi hiệu suất và lỗi của ứng dụng</li>
        <li>Phân tích việc sử dụng Dịch vụ</li>
        <li>Cải thiện Dịch vụ hiện tại và phát triển tính năng mới</li>
        <li>
          Thực hiện thống kê và nghiên cứu khoa học bằng dữ liệu đã được ẩn danh
        </li>
        <li>
          Tuân thủ pháp luật và đáp ứng yêu cầu hợp pháp của cơ quan có thẩm
          quyền
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Chúng tôi không bán hoặc cho thuê dữ liệu cá nhân của người dùng.
      </PolicyText>

      <PolicySectionTitle>
        3. Dữ liệu sức khỏe và dữ liệu cá nhân nhạy cảm
      </PolicySectionTitle>
      <PolicyText>
        <strong>pregnancy&amp;baby</strong> cung cấp các tính năng liên quan đến
        chuẩn bị mang thai, kinh nguyệt, điều trị hiếm muộn, thai kỳ, sức khỏe
        của người mẹ và chăm sóc trẻ.
      </PolicyText>
      <PolicyText>
        Do đó, một số dữ liệu do người dùng cung cấp có thể được phân loại là{" "}
        <strong>dữ liệu cá nhân nhạy cảm</strong> theo pháp luật bảo vệ dữ liệu
        cá nhân hiện hành của Việt Nam.
      </PolicyText>
      <PolicyText>
        Chúng tôi chỉ xử lý các dữ liệu này để cung cấp các tính năng mà người
        dùng lựa chọn, cho các mục đích được thông báo trong Chính sách này hoặc
        bằng phương thức khác, và trong phạm vi pháp luật cho phép.
      </PolicyText>
      <PolicyText>
        Trong trường hợp pháp luật yêu cầu phải có sự đồng ý đối với việc thu
        thập hoặc xử lý dữ liệu sức khỏe hoặc dữ liệu cá nhân nhạy cảm khác,
        chúng tôi sẽ xin sự đồng ý cần thiết của người dùng.
      </PolicyText>
      <PolicyText>
        Chúng tôi không bán dữ liệu sức khỏe hoặc dữ liệu cá nhân nhạy cảm của
        người dùng.
      </PolicyText>

      <PolicySectionTitle>
        4. Phân tích tự động và dịch vụ cá nhân hóa
      </PolicySectionTitle>
      <PolicyText>
        Một số tính năng của <strong>pregnancy&amp;baby</strong> phân tích dữ
        liệu do người dùng cung cấp để cung cấp kết quả phù hợp với người dùng.
      </PolicyText>
      <PolicyText>Ví dụ, dữ liệu có thể được phân tích để:</PolicyText>
      <PolicyHyphenList>
        <li>Dự đoán kỳ kinh tiếp theo và thời điểm dễ thụ thai</li>
        <li>Dự đoán ngày rụng trứng</li>
        <li>Phân tích hình ảnh xét nghiệm rụng trứng hoặc xét nghiệm thai</li>
        <li>Tính toán tiến trình thai kỳ</li>
        <li>Phân tích các chỉ số tăng trưởng của thai nhi</li>
        <li>Phân tích sự thay đổi cân nặng của người mẹ</li>
        <li>Phân tích sự tăng trưởng và phát triển của trẻ</li>
      </PolicyHyphenList>
      <PolicyText>
        Các kết quả phân tích này được cung cấp nhằm mục đích cung cấp thông tin
        và hỗ trợ người dùng trong Dịch vụ, không thay thế chẩn đoán, điều trị
        hoặc tư vấn y tế của bác sĩ hay chuyên gia y tế.
      </PolicyText>

      <PolicySectionTitle>
        5. Thông báo đẩy và các thông báo khác
      </PolicySectionTitle>
      <PolicyText>
        Dựa trên sự đồng ý hoặc cài đặt của người dùng, chúng tôi có thể gửi
        thông báo đẩy liên quan đến:
      </PolicyText>
      <PolicyHyphenList>
        <li>Lời nhắc sử dụng Dịch vụ</li>
        <li>Lời nhắc về nhật ký và thông tin sức khỏe</li>
        <li>Thông tin liên quan đến thai kỳ hoặc chăm sóc trẻ</li>
        <li>Cập nhật Dịch vụ</li>
        <li>
          Sự kiện, chương trình khuyến mại hoặc thông tin khác mà người dùng đã
          đồng ý nhận riêng
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Để gửi thông báo đẩy, chúng tôi xử lý mã đăng ký FCM hoặc mã thông báo
        tương đương.
      </PolicyText>
      <PolicyText>
        Người dùng có thể thay đổi cài đặt thông báo bất cứ lúc nào trong Dịch
        vụ hoặc cài đặt thiết bị.
      </PolicyText>
      <PolicyText>
        Ngay cả khi người dùng tắt các thông báo tùy chọn, chúng tôi vẫn có thể
        gửi các thông báo quan trọng cần thiết để cung cấp Dịch vụ trong phạm vi
        pháp luật cho phép.
      </PolicyText>

      <PolicySectionTitle>6. Cookie và công nghệ tương tự</PolicySectionTitle>
      <PolicyText>
        Trang web của chúng tôi có thể sử dụng cookie và công nghệ tương tự khi
        cần thiết để vận hành Dịch vụ, lưu cài đặt, hiểu cách Dịch vụ được sử
        dụng và cải thiện trải nghiệm người dùng.
      </PolicyText>
      <PolicyText>
        Người dùng có thể quản lý cookie thông qua cài đặt trình duyệt. Tuy
        nhiên, nếu vô hiệu hóa một số cookie, một số chức năng của trang web có
        thể không hoạt động bình thường.
      </PolicyText>

      <PolicySectionTitle>7. Nhà cung cấp dịch vụ bên ngoài</PolicySectionTitle>
      <PolicyText>
        Chúng tôi sử dụng các nhà cung cấp dịch vụ bên ngoài để vận hành, duy
        trì, phân tích và cải thiện Dịch vụ.
      </PolicyText>
      <PolicyTable>
        <caption className="hide">
          Loại dịch vụ, Nhà cung cấp, Dữ liệu liên quan, Mục đích
        </caption>
        <colgroup>
          <col style={{ width: "20%" }} />
          <col style={{ width: "20%" }} />
          <col />
          <col style={{ width: "25%" }} />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">Loại dịch vụ</th>
            <th scope="col">Nhà cung cấp</th>
            <th scope="col">Dữ liệu liên quan</th>
            <th scope="col">Mục đích</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Cơ sở hạ tầng và lưu trữ</td>
            <td>Amazon Web Services (AWS)</td>
            <td className="cell_left">
              Dữ liệu cá nhân được xử lý thông qua Dịch vụ
            </td>
            <td className="cell_left">Lưu trữ và vận hành hạ tầng</td>
          </tr>
          <tr>
            <td>Dịch vụ liên lạc</td>
            <td>NHN Cloud</td>
            <td className="cell_left">
              Thông tin liên hệ và dữ liệu liên quan đến liên lạc
            </td>
            <td className="cell_left">Gửi tin nhắn và thông báo dịch vụ</td>
          </tr>
          <tr>
            <td>Phân tích</td>
            <td>Google Analytics for Firebase</td>
            <td className="cell_left">Dữ liệu sử dụng và phân tích ứng dụng</td>
            <td className="cell_left">Phân tích và cải thiện Dịch vụ</td>
          </tr>
          <tr>
            <td>Xử lý hình ảnh</td>
            <td>Google Cloud Vision</td>
            <td className="cell_left">
              Hình ảnh được tải lên cho tính năng phân tích hình ảnh
            </td>
            <td className="cell_left">
              Phân tích hình ảnh và cung cấp chức năng
            </td>
          </tr>
          <tr>
            <td>Giám sát ứng dụng</td>
            <td>Sentry</td>
            <td className="cell_left">
              Nhật ký ứng dụng, dữ liệu lỗi và chẩn đoán
            </td>
            <td className="cell_left">Giám sát hiệu suất và theo dõi lỗi</td>
          </tr>
        </tbody>
      </PolicyTable>
      <PolicyText>
        Các nhà cung cấp dịch vụ bên ngoài chỉ xử lý dữ liệu trong phạm vi cần
        thiết để cung cấp dịch vụ cho chúng tôi và phải tuân thủ các nghĩa vụ
        hợp đồng và pháp luật hiện hành.
      </PolicyText>
      <PolicyText>
        Danh sách nhà cung cấp có thể thay đổi khi Dịch vụ được cập nhật hoặc
        thay đổi.
      </PolicyText>

      <PolicySectionTitle>
        8. Trường hợp chia sẻ hoặc cung cấp dữ liệu cá nhân
      </PolicySectionTitle>
      <PolicyText>
        Chúng tôi không bán hoặc cho thuê dữ liệu cá nhân của người dùng.
      </PolicyText>
      <PolicyText>
        Chúng tôi chỉ có thể chia sẻ hoặc cung cấp dữ liệu cá nhân trong phạm vi
        cần thiết trong các trường hợp như:
      </PolicyText>
      <PolicyHyphenList>
        <li>
          Giao việc xử lý dữ liệu cho nhà cung cấp dịch vụ hỗ trợ hoạt động của
          chúng tôi
        </li>
        <li>Khi người dùng yêu cầu hoặc đồng ý với việc cung cấp</li>
        <li>
          Khi cần thiết để tuân thủ pháp luật, quyết định của tòa án hoặc yêu
          cầu hợp pháp của cơ quan nhà nước có thẩm quyền
        </li>
        <li>
          Khi cần thiết một cách hợp lý để bảo vệ quyền, an toàn hoặc bảo mật
          của người dùng, người dùng khác, Công ty hoặc Dịch vụ
        </li>
        <li>
          Trong trường hợp sáp nhập, mua lại, tái cấu trúc, huy động vốn, chuyển
          nhượng doanh nghiệp hoặc tài sản hay giao dịch doanh nghiệp tương tự
          trong phạm vi pháp luật cho phép
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Thông tin đã được ẩn danh không thể đảo ngược để không thể nhận dạng hợp
        lý một cá nhân có thể được sử dụng hoặc chia sẻ theo quy định của pháp
        luật hiện hành.
      </PolicyText>

      <PolicySectionTitle>
        9. Dữ liệu ẩn danh và sử dụng cho nghiên cứu
      </PolicySectionTitle>
      <PolicyText>
        Chúng tôi có thể ẩn danh một số dữ liệu được tạo ra trong quá trình sử
        dụng Dịch vụ để sử dụng cho mục đích thống kê, phân tích, nghiên cứu
        khoa học và cải thiện Dịch vụ.
      </PolicyText>
      <PolicyText>
        Nghiên cứu có thể liên quan đến sức khỏe phụ nữ, chuẩn bị mang thai,
        thai kỳ, sức khỏe người mẹ cũng như sự tăng trưởng và phát triển của
        trẻ.
      </PolicyText>
      <PolicyText>Quy trình ẩn danh của chúng tôi nhằm:</PolicyText>
      <PolicyHyphenList>
        <li>
          Bảo đảm người dùng không thể được nhận dạng một cách hợp lý từ dữ liệu
        </li>
        <li>
          Loại bỏ các thông tin định danh có thể liên kết dữ liệu với tài khoản
          người dùng
        </li>
        <li>
          Ngăn dữ liệu đã ẩn danh được liên kết trở lại với tài khoản hoặc dữ
          liệu cá nhân của người dùng
        </li>
        <li>
          Bảo đảm chúng tôi không thể tái nhận dạng người dùng từ dữ liệu đã ẩn
          danh
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Dữ liệu đã được ẩn danh không thể đảo ngược sẽ được xử lý theo pháp luật
        hiện hành.
      </PolicyText>
      <PolicyText>
        <strong>
          Dữ liệu đã ẩn danh có thể được lưu giữ vô thời hạn cho mục đích nghiên
          cứu, thống kê, phân tích và cải thiện Dịch vụ
        </strong>
        .
      </PolicyText>
      <PolicyText>
        Khi không thể nhận dạng hợp lý một cá nhân, chúng tôi có thể sử dụng
        hoặc chia sẻ dữ liệu hoặc kết quả nghiên cứu đã được ẩn danh hoặc tổng
        hợp với tổ chức nghiên cứu hoặc các đối tác khác.
      </PolicyText>

      <PolicySectionTitle>
        10. Thời gian lưu trữ dữ liệu cá nhân và xóa tài khoản
      </PolicySectionTitle>
      <PolicyText>
        Chúng tôi chỉ lưu trữ dữ liệu cá nhân có thể nhận dạng người dùng trong
        thời gian hợp lý cần thiết để cung cấp Dịch vụ, thực hiện các mục đích
        nêu trong Chính sách này hoặc tuân thủ nghĩa vụ pháp lý.
      </PolicyText>
      <PolicyList>
        <li>
          <strong>Xóa tài khoản</strong>
          <br />
          Người dùng có thể xóa tài khoản bằng chức năng xóa tài khoản/hủy tài
          khoản trong Dịch vụ hoặc gửi yêu cầu cho chúng tôi.
          <br />
          Khi tài khoản bị xóa:
          <PolicyHyphenList>
            <li>Tài khoản của người dùng sẽ bị chấm dứt.</li>
            <li>
              Dữ liệu cá nhân có thể nhận dạng người dùng sẽ được xóa hoặc tiêu
              hủy theo pháp luật hiện hành.
            </li>
            <li>
              Nếu người dùng tạo tài khoản mới sau này, dữ liệu cá nhân của tài
              khoản cũ sẽ không được khôi phục hoặc sử dụng lại.
            </li>
          </PolicyHyphenList>
          Tuy nhiên, chúng tôi có thể lưu giữ một số thông tin trong thời gian
          cần thiết nếu pháp luật yêu cầu hoặc cho phép, chẳng hạn để thực hiện
          nghĩa vụ pháp lý, giải quyết tranh chấp, ngăn chặn hành vi gian lận
          hoặc thực thi quyền theo hợp đồng.
          <br />
          Như được mô tả tại Mục 9, một số dữ liệu liên quan đến việc sử dụng
          Dịch vụ có thể được <strong>ẩn danh không thể đảo ngược</strong> trước
          hoặc trong quá trình xóa tài khoản và được lưu giữ vô thời hạn cho mục
          đích nghiên cứu, thống kê, phân tích và cải thiện Dịch vụ. Dữ liệu đã
          được ẩn danh như vậy không thể được liên kết trở lại với người dùng.
        </li>
        <li>
          <strong>Xóa ứng dụng</strong>
          <br />
          Việc gỡ cài đặt ứng dụng <strong>pregnancy&amp;baby</strong> khỏi
          thiết bị không tự động xóa tài khoản hoặc dữ liệu cá nhân.
          <br />
          Để xóa dữ liệu cá nhân, người dùng phải xóa tài khoản trong Dịch vụ
          hoặc gửi yêu cầu xóa cho chúng tôi.
        </li>
      </PolicyList>

      <PolicySectionTitle>11. Quyền của chủ thể dữ liệu</PolicySectionTitle>
      <PolicyText>
        Theo pháp luật hiện hành, người dùng có thể có các quyền liên quan đến
        dữ liệu cá nhân của mình, bao gồm:
      </PolicyText>
      <PolicyHyphenList>
        <li>Được biết về hoạt động xử lý dữ liệu cá nhân</li>
        <li>
          Đồng ý hoặc không đồng ý với việc xử lý trong các trường hợp pháp luật
          quy định
        </li>
        <li>Rút lại sự đồng ý</li>
        <li>Truy cập hoặc xem dữ liệu cá nhân của mình</li>
        <li>Yêu cầu chỉnh sửa dữ liệu cá nhân</li>
        <li>
          Yêu cầu xóa dữ liệu cá nhân trong các trường hợp pháp luật quy định
        </li>
        <li>
          Yêu cầu hạn chế hoặc phản đối việc xử lý trong các trường hợp áp dụng
        </li>
        <li>Yêu cầu cung cấp dữ liệu cá nhân theo quy định của pháp luật</li>
        <li>
          Khiếu nại, tố cáo hoặc yêu cầu bồi thường theo quy định của pháp luật
        </li>
        <li>Thực hiện các quyền khác theo pháp luật hiện hành</li>
      </PolicyHyphenList>
      <PolicyText>
        Việc rút lại sự đồng ý không ảnh hưởng đến tính hợp pháp của hoạt động
        xử lý đã được thực hiện trước thời điểm rút lại.
      </PolicyText>
      <PolicyText>
        Một số giới hạn hoặc ngoại lệ có thể áp dụng theo pháp luật.
      </PolicyText>
      <PolicyText>
        Để thực hiện quyền của mình hoặc gửi yêu cầu liên quan đến dữ liệu cá
        nhân, vui lòng liên hệ:
        <br />
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
      </PolicyText>
      <PolicyText>
        Chúng tôi có thể yêu cầu thông tin hợp lý cần thiết để xác minh danh
        tính trước khi xử lý yêu cầu.
      </PolicyText>

      <PolicySectionTitle>
        12. Biện pháp bảo vệ dữ liệu cá nhân
      </PolicySectionTitle>
      <PolicyText>
        Chúng tôi áp dụng các biện pháp kỹ thuật và tổ chức hợp lý nhằm bảo vệ
        dữ liệu cá nhân khỏi truy cập trái phép, mất mát, trộm cắp, sử dụng sai
        mục đích, tiết lộ trái phép, thay đổi hoặc phá hủy.
      </PolicyText>
      <PolicyText>Các biện pháp này có thể bao gồm:</PolicyText>
      <PolicyHyphenList>
        <li>Mã hóa dữ liệu khi truyền và lưu trữ khi phù hợp</li>
        <li>Kiểm soát quyền truy cập</li>
        <li>Giám sát hệ thống</li>
        <li>Quản lý lỗ hổng bảo mật</li>
        <li>Quy trình bảo mật nội bộ</li>
        <li>Hạn chế quyền truy cập dữ liệu cá nhân theo nhu cầu công việc</li>
      </PolicyHyphenList>
      <PolicyText>
        Chỉ những nhân sự cần truy cập dữ liệu để thực hiện nhiệm vụ mới được
        cấp quyền phù hợp.
      </PolicyText>
      <PolicyText>
        Tuy nhiên, không có phương thức truyền hoặc lưu trữ điện tử nào có thể
        được bảo đảm an toàn tuyệt đối.
      </PolicyText>
      <PolicyText>
        Nếu xảy ra sự cố liên quan đến dữ liệu cá nhân, chúng tôi sẽ thực hiện
        các biện pháp phù hợp và thông báo hoặc báo cáo cho người dùng và cơ
        quan có thẩm quyền khi pháp luật yêu cầu.
      </PolicyText>

      <PolicySectionTitle>
        13. Nơi lưu trữ và xử lý dữ liệu ngoài Việt Nam
      </PolicySectionTitle>
      <PolicyText>
        Connecti Co., Ltd. có trụ sở tại <strong>Hàn Quốc</strong>.
      </PolicyText>
      <PolicyText>
        Cơ sở hạ tầng ứng dụng chính và việc lưu trữ dữ liệu của Dịch vụ sử dụng{" "}
        <strong>
          Amazon Web Services (AWS), khu vực Châu Á – Thái Bình Dương (Seoul),
          Hàn Quốc.
        </strong>
      </PolicyText>
      <PolicyText>
        Do đó, dữ liệu cá nhân của người dùng tại Việt Nam có thể được lưu trữ
        và xử lý tại Hàn Quốc.
      </PolicyText>
      <PolicyText>
        Ngoài ra, vì <strong>pregnancy&amp;baby</strong> sử dụng các nhà cung
        cấp dịch vụ toàn cầu, một số dữ liệu cá nhân hoặc dữ liệu kỹ thuật có
        thể được xử lý hoặc truy cập bởi nhà cung cấp dịch vụ đặt tại quốc gia
        khác với quốc gia cư trú của người dùng.
      </PolicyText>
      <PolicyText>Các nhà cung cấp liên quan có thể bao gồm:</PolicyText>
      <PolicyHyphenList>
        <li>Amazon Web Services</li>
        <li>Google</li>
        <li>NHN Cloud</li>
        <li>Sentry</li>
      </PolicyHyphenList>
      <PolicyText>
        Chúng tôi sẽ thực hiện việc chuyển dữ liệu cá nhân ra nước ngoài và các
        hoạt động xử lý dữ liệu xuyên biên giới theo pháp luật Việt Nam về bảo
        vệ dữ liệu cá nhân và các quy định pháp luật hiện hành khác, đồng thời
        thực hiện các biện pháp, thủ tục, hồ sơ hoặc nghĩa vụ thông báo cần
        thiết khi pháp luật yêu cầu.
      </PolicyText>

      <PolicySectionTitle>
        14. Dữ liệu cá nhân của người chưa thành niên
      </PolicySectionTitle>
      <PolicyText>
        Dịch vụ chỉ dành cho những người đã đạt độ tuổi mà theo pháp luật áp
        dụng, họ có thể{" "}
        <strong>
          tự mình đưa ra sự đồng ý hợp lệ đối với việc thu thập và xử lý dữ liệu
          cá nhân của mình
        </strong>
        .
      </PolicyText>
      <PolicyText>
        Nếu pháp luật yêu cầu phải có sự đồng ý của cha mẹ, người giám hộ hoặc
        người đại diện theo pháp luật để sử dụng Dịch vụ hoặc xử lý dữ liệu cá
        nhân, người chưa có sự đồng ý cần thiết không được tạo hoặc sử dụng tài
        khoản <strong>pregnancy&amp;baby</strong>.
      </PolicyText>
      <PolicyText>
        Chúng tôi không cố ý thu thập dữ liệu cá nhân từ người chưa đủ khả năng
        tự mình đưa ra sự đồng ý hợp lệ và chưa có sự đồng ý cần thiết của cha
        mẹ, người giám hộ hoặc người đại diện theo pháp luật.
      </PolicyText>
      <PolicyText>
        Nếu bạn cho rằng dữ liệu cá nhân của người chưa thành niên đã được cung
        cấp cho chúng tôi không phù hợp với pháp luật, vui lòng liên hệ{" "}
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
        . Chúng tôi sẽ xem xét và thực hiện biện pháp thích hợp, bao gồm xóa dữ
        liệu khi cần thiết.
      </PolicyText>

      <PolicySectionTitle>
        15. Dữ liệu cá nhân của trẻ do người dùng đăng ký
      </PolicySectionTitle>
      <PolicyText>
        Một số tính năng chăm sóc trẻ cho phép cha mẹ, người giám hộ hoặc người
        đại diện hợp pháp nhập dữ liệu liên quan đến trẻ.
      </PolicyText>
      <PolicyText>Dữ liệu này có thể bao gồm:</PolicyText>
      <PolicyHyphenList>
        <li>Họ tên</li>
        <li>Giới tính</li>
        <li>Ngày sinh</li>
        <li>Thông tin cơ thể khi sinh</li>
        <li>Dữ liệu tăng trưởng</li>
        <li>Dữ liệu phát triển</li>
        <li>Thông tin khám sức khỏe</li>
        <li>Thông tin tiêm chủng</li>
        <li>Thân nhiệt</li>
        <li>Thông tin sử dụng thuốc</li>
        <li>Thông tin bệnh lý</li>
        <li>Hình ảnh liên quan</li>
      </PolicyHyphenList>
      <PolicyText>
        Khi nhập dữ liệu cá nhân của trẻ vào Dịch vụ, người dùng xác nhận rằng
        mình có quyền hợp pháp để cung cấp và quản lý dữ liệu đó với tư cách cha
        mẹ, người giám hộ, người đại diện theo pháp luật hoặc người có thẩm
        quyền hợp pháp khác.
      </PolicyText>
      <PolicyText>
        Chúng tôi chỉ xử lý dữ liệu này cho các mục đích được nêu trong Chính
        sách này và trong phạm vi pháp luật cho phép.
      </PolicyText>

      <PolicySectionTitle>
        16. Dịch vụ đăng nhập và dịch vụ bên thứ ba
      </PolicySectionTitle>
      <PolicyText>
        Khi người dùng đăng nhập vào <strong>pregnancy&amp;baby</strong> bằng
        Google, Apple, việc sử dụng các dịch vụ đó cũng chịu sự điều chỉnh của
        điều khoản sử dụng và chính sách quyền riêng tư của từng nhà cung cấp.
      </PolicyText>
      <PolicyText>
        Dịch vụ cũng có thể chứa liên kết đến trang web, ứng dụng hoặc dịch vụ
        do bên thứ ba vận hành.
      </PolicyText>
      <PolicyText>
        Chúng tôi không chịu trách nhiệm đối với hoạt động xử lý dữ liệu cá nhân
        độc lập của bên thứ ba. Người dùng nên xem chính sách quyền riêng tư của
        bên thứ ba trước khi cung cấp dữ liệu cá nhân cho họ.
      </PolicyText>

      <PolicySectionTitle>17. Không bán dữ liệu cá nhân</PolicySectionTitle>
      <PolicyText>
        Chúng tôi không bán hoặc cho thuê dữ liệu cá nhân của người dùng.
      </PolicyText>
      <PolicyText>
        Chúng tôi cũng không bán dữ liệu cá nhân liên quan đến sức khỏe, chuẩn
        bị mang thai, thai kỳ hoặc trẻ em.
      </PolicyText>

      <PolicySectionTitle>
        18. Thay đổi Chính sách quyền riêng tư
      </PolicySectionTitle>
      <PolicyText>
        Chúng tôi có thể sửa đổi Chính sách quyền riêng tư này để phản ánh:
      </PolicyText>
      <PolicyHyphenList>
        <li>Thay đổi đối với Dịch vụ</li>
        <li>Thay đổi trong cách chúng tôi xử lý dữ liệu cá nhân</li>
        <li>Thay đổi nhà cung cấp dịch vụ</li>
        <li>Thay đổi pháp luật hoặc quy định hiện hành</li>
      </PolicyHyphenList>
      <PolicyText>
        Nếu thay đổi có ảnh hưởng đáng kể đến quyền của người dùng hoặc cách
        chúng tôi xử lý dữ liệu cá nhân, chúng tôi sẽ thông báo bằng phương thức
        thích hợp trước khi thay đổi có hiệu lực theo quy định của pháp luật.
      </PolicyText>
      <PolicyText>
        Khi pháp luật yêu cầu, chúng tôi sẽ xin lại sự đồng ý của người dùng.
      </PolicyText>
      <PolicyText>
        Ngày có hiệu lực và ngày cập nhật gần nhất sẽ được hiển thị ở đầu Chính
        sách này.
      </PolicyText>

      <PolicySectionTitle>
        19. Liên hệ về bảo vệ dữ liệu cá nhân
      </PolicySectionTitle>
      <PolicyText>
        Nếu có câu hỏi về Chính sách quyền riêng tư này, cách chúng tôi xử lý dữ
        liệu cá nhân hoặc muốn thực hiện các quyền liên quan đến dữ liệu cá
        nhân, vui lòng liên hệ:
      </PolicyText>
      <PolicyText>
        <strong>Connecti Co., Ltd.</strong>
        <br />
        B2F, Unit 56
        <br />
        176 Yanghwa-ro, Mapo-gu
        <br />
        Seoul, Republic of Korea
        <br />
        <strong>Email:</strong>{" "}
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
      </PolicyText>

      <PolicySectionTitle>
        20. Quy định áp dụng đối với người dùng tại Việt Nam
      </PolicySectionTitle>
      <PolicyText>
        Đối với dữ liệu cá nhân của người dùng tại Việt Nam, chúng tôi xử lý dữ
        liệu theo{" "}
        <strong>
          Luật Bảo vệ dữ liệu cá nhân số 91/2025/QH15, Nghị định số
          356/2025/NĐ-CP
        </strong>{" "}
        và các quy định pháp luật Việt Nam có liên quan. Luật và Nghị định này
        đều có hiệu lực từ ngày 1 tháng 1 năm 2026. (vanban)
      </PolicyText>
      <PolicyText>
        Người dùng tại Việt Nam có thể thực hiện các quyền của chủ thể dữ liệu
        theo quy định của pháp luật Việt Nam, bao gồm các quyền liên quan đến
        việc được biết, đồng ý, rút lại sự đồng ý, truy cập, chỉnh sửa, xóa, hạn
        chế hoặc phản đối việc xử lý và các quyền khác được pháp luật công nhận.
      </PolicyText>
      <PolicyText>
        Đối với <strong>dữ liệu cá nhân nhạy cảm</strong>, bao gồm dữ liệu sức
        khỏe thuộc phạm vi áp dụng, chúng tôi thực hiện các biện pháp bảo vệ và
        thủ tục cần thiết theo pháp luật Việt Nam.
      </PolicyText>
      <PolicyText>
        Do cơ sở hạ tầng chính của <strong>pregnancy&amp;baby</strong> được đặt
        tại Hàn Quốc và một số nhà cung cấp dịch vụ có thể xử lý dữ liệu ngoài
        Việt Nam, dữ liệu của người dùng Việt Nam có thể được chuyển ra nước
        ngoài. Chúng tôi sẽ thực hiện việc chuyển dữ liệu này và các nghĩa vụ
        liên quan theo quy định pháp luật Việt Nam về bảo vệ dữ liệu cá nhân.
      </PolicyText>
      <PolicyText>
        Để thực hiện quyền của chủ thể dữ liệu hoặc gửi yêu cầu liên quan đến
        việc xử lý dữ liệu cá nhân, vui lòng liên hệ:
        <br />
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
      </PolicyText>
    </PolicyContainer>
  );
};

export default PrivacyVi;
